import {ApDynformsConfigFieldset}       from '../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {ApDynformsValidator}            from '../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                     from '@angular/forms';
import {ApDynformsConfigNumerictextbox} from '../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {AgriportConstantsService}       from '../../../services/common/agriport-constants.service';
import {ApDynformsConfigPlaceholder}    from '../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {Injectable}                     from '@angular/core';
import {AgriportConstantsEnum}          from '../../../ap-interface/enums/ap-agriport-constants.enum';

@Injectable()
export class BoniturConfig {
  constructor(private agriportConstantsService: AgriportConstantsService) {
  }

  public formBuilder(values: any, isModalField: boolean): ApDynformsConfigFieldset[] {
    return [
      new ApDynformsConfigFieldset({
        key: 'Agronomy',
        legend: 'Global__Agronomy',
        useMaxWidth: isModalField,
        config: [
          new ApDynformsConfigNumerictextbox({
            key: 'ECStage',
            label: 'Global__ECStage',
            value: values['ECStage'],
            decimals: 0,
            format: 'n0',
            step: 1,
            min: +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.EcMin),
            max: +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.EcMax),
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'}),
            ]
          }),
          new ApDynformsConfigPlaceholder({})
        ]
      })
    ];
  }
}
